import { Route, Routes } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "leaflet/dist/leaflet.css";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-zoom.css";
import "./App.css";
import { Home } from "./pages/home/Home";
import { Gallery } from "./pages/gallery/Gallery";
import { About } from "./pages/about/About";
import Loaders from "./component/comman/loader/Loader";
import { Layout } from "./component/layout/Layout";
import { Deities } from "./pages/deities/Deities";
import { Support } from "./pages/support/Support";
import { Pooja } from "./pages/pooja/Pooja";
import { Transport } from "./pages/transport/Transport";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleLoad = () => {
      setTimeout(() => {
        setLoading(false);
      },1000);
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => window.removeEventListener("load", handleLoad);
  }, []); 

  return (
    <>
      {loading && <Loaders/>}
      <Routes>
        <Route index element={<Home />} />
        <Route path="/" element={<Layout />}>
          <Route path="gallery" element={<Gallery />} />
          <Route path="about" element={<About />} />
          <Route path="deities" element={<Deities />} />
          <Route path="pooja" element={<Pooja />} />
          <Route path="transport" element={<Transport />} />
        </Route>

        <Route path="/support" element={<Support />} />
      </Routes>
    </>
  );
}

export default App;
